var map = {
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB.svg": 363,
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB@2x.png": 364,
	"./BlueSocialIcon/facebook.svg": 365,
	"./BlueSocialIcon/share-icon-bg.svg": 366,
	"./BlueSocialIcon/share-icon-black.svg": 367,
	"./BlueSocialIcon/share-icon-close.svg": 368,
	"./BlueSocialIcon/share-icon-open.svg": 369,
	"./BlueSocialIcon/share-icon.svg": 370,
	"./BlueSocialIcon/twitter.svg": 371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 362;